// extracted by mini-css-extract-plugin
export default {"innerWrapper":"DB-z","tooltipWrapper":"EB-z","icon":"FB-z","tooltip":"GB-z","content":"HB-z"};